/* tslint:disable */
/* eslint-disable */
/**
 * Viewup Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface AdminGetExchangeCancelCategoryDataResponseDto
 */
export interface AdminGetExchangeCancelCategoryDataResponseDto {
    /**
     * 환급 불가 사유 id
     * @type {number}
     * @memberof AdminGetExchangeCancelCategoryDataResponseDto
     */
    'exchangeCancelCategoryId': number;
    /**
     * 이름
     * @type {string}
     * @memberof AdminGetExchangeCancelCategoryDataResponseDto
     */
    'name': AdminGetExchangeCancelCategoryDataResponseDtoNameEnum;
}

export const AdminGetExchangeCancelCategoryDataResponseDtoNameEnum = {
    ExchangeableAmountLessThanAmountRequest: 'exchangeableAmountLessThanAmountRequest',
    ReasonsForReceivingBank: 'reasonsForReceivingBank',
    AccountHolderNameIsDifferent: 'accountHolderNameIsDifferent',
    RevokedAccount: 'revokedAccount',
    SuspendedAccount: 'suspendedAccount',
    Other: 'other'
} as const;

export type AdminGetExchangeCancelCategoryDataResponseDtoNameEnum = typeof AdminGetExchangeCancelCategoryDataResponseDtoNameEnum[keyof typeof AdminGetExchangeCancelCategoryDataResponseDtoNameEnum];


